export default __webpack_public_path__ + "static/media/food.6a15bbf0.svg";